import type { Theme } from "@mui/material";
import type { SystemStyleObject } from "@mui/system";

const TILE_MIN_WIDTH = 232;
const TILE_GAP = 20;

export const tileGridSx: SystemStyleObject<Theme> = {
  display: "grid",
  gridTemplateColumns: `repeat(auto-fill, minmax(${TILE_MIN_WIDTH}px, 1fr))`,
  gap: `${TILE_GAP}px`,
};

const getLineWidth = (tileCount: number): number => tileCount * TILE_MIN_WIDTH + (tileCount - 1) * TILE_GAP;

export const getOneLineTileGridSx = (tileCount: number): SystemStyleObject<Theme> => ({
  ...tileGridSx,
  containerType: "inline-size",
  ...Object.fromEntries<SystemStyleObject<Theme>>(
    Array.from({ length: tileCount - 1 }, (_, index) => {
      const position = index + 2;
      return [
        `@container (width < ${getLineWidth(position)}px)`,
        { [`& > :nth-of-type(${position})`]: { display: "none" } },
      ];
    })
  ),
});
